"use client";

import { useContext, useEffect, useRef, useState } from 'react';
import SectionHeader from '@/elements/Sectionheader';
import { CardSectionProps } from '@/interfaces';
import ProgramDetailCard from '../Programdetailcard';
import './index.scss';
import TypoGraphy from '@/typography';
import useViewType from '@/utils/Hooks/useViewType';
import Button from '@/uicomponents/Button';
import { RouteStrings } from '@/utils/routestrings';
import { useParams, useRouter } from 'next/navigation';
import { AppContext } from '@/contexts/appcontext';
import { getSlugAndRouteName } from '@/utils/Functions';
import NoCards from '@/utilitycomponents/NoCards';
import { API_ENDPOINTS } from '@/services/endPoints';
import { apiService } from '@/services/apiService';
const CardSection = ({
  data,
  title,
  currentSubIndustry,
  styles,
  isFilterArray,
  industryName,
  subIndustryName
}: CardSectionProps) => {
  const params = useParams();
  const {
    isIndustry,
    isSubIndustry,
    slug,
    isSingleCourse,
    isTopic,
    isSubTopic,
    isArticle
  } = getSlugAndRouteName(params?.route?.toString() || '');
  const [filterText, setfilterText] = useState(isSubIndustry ? currentSubIndustry : 'All');
  const [activefilter, setActiveFilter] = useState<any>(isSubIndustry ? currentSubIndustry : 'All');
  const [disableLeft, setdisableLeft] = useState(true);
  const [disableRight, setdisableRight] = useState(false);
  const [element, setElement] = useState<Element | null>(null);
  const oneRowSection = isSingleCourse || isTopic || isSubTopic || isArticle;
  const handleFilterClick = (text: string, index?: number, id?: number) => {
    if ((isIndustry || isSubIndustry) && id) {
      push(RouteStrings.DYNAMICROUTE(text.replaceAll(' ', '-'), 'SUBINDUSTRY', id));
    }
    setfilterText(text);
    if (typeof index === 'number') setActiveFilter(index);else setActiveFilter("All");
  };
  useEffect(() => {
    if (element) element.scrollTo(0, 0);
  }, [activefilter]);
  const isMobile = useViewType();
  const {
    push
  } = useRouter();
  const handleLeftClick = () => {
    if (element) element.scrollLeft -= oneRowSection ? 300 : 600;
  };
  const handleRighClick = () => {
    if (element) {
      element.scrollLeft += oneRowSection ? 300 : 600;
    }
  };
  const showFilters = () => {
    if (isIndustry && isMobile || isSubIndustry && isMobile) return false;
    return true;
  };
  const handleScroll = (e: any) => {
    if (e?.currentTarget?.children && element) {
      let width = e?.currentTarget?.children[0]?.clientWidth;
      const left = element?.scrollLeft;
      let max = element.scrollWidth - element.clientWidth;
      if (oneRowSection) {
        width = e?.currentTarget?.children[0]?.children[0]?.clientWidth;
      }
      if (left > width && disableLeft) {
        setdisableLeft(false);
      } else {
        setdisableLeft(true);
      }
      if (left > max - (width - 36)) {
        setdisableRight(true);
      } else {
        setdisableRight(false);
      }
    }
  };
  useEffect(() => {
    element?.addEventListener('scroll', handleScroll);
    return () => {
      element?.removeEventListener('scroll', handleScroll);
    };
  }, [element]);
  if (!data?.cards?.length) return <></>;
  const [card] = data.cards;
  const industry = card?.attributes?.industries?.data[0];
  const handleSeeAll = () => {
    push(RouteStrings.DYNAMICROUTE(industry?.attributes?.industryName, 'INDUSTRY', industry?.id));
  };
  return <div className="section_wrapper" style={styles} data-sentry-component="CardSection" data-sentry-source-file="index.tsx">
            {title && <div className="title_wrapper">
                <SectionHeader text={title} isSeeAll showButtons disableLeft={disableLeft} disableRight={disableRight} handleLeftClick={handleLeftClick} handleRightClick={handleRighClick} handleSeeAll={handleSeeAll} industryName={industryName} href={RouteStrings.DYNAMICROUTE(industry?.attributes?.industryName, 'INDUSTRY', industry?.id)} />
            </div>}
            <div className="filter_and_cards_wrapper">
                {showFilters() && <div className="filters_wrapper">
                    {!isIndustry && !isSubIndustry && <a href='#' className={activefilter === "All" ? "filter filter_active" : "filter"} onClick={(e: any) => {
          e.preventDefault();
          handleFilterClick("All");
        }}>
                        <TypoGraphy text={"All"} variant={isMobile ? 'Mobile/Body 2/R | 14 | 120' : 'Desktop/Body 2/R | 14 |120'} />
                    </a>}
                    {isFilterArray ? data?.filters?.map((element: any, index: number) => {
          return <a href={RouteStrings.DYNAMICROUTE(element?.attributes?.subIndustry, 'SUBINDUSTRY', element?.id)} title={`Free ${element?.attributes?.subIndustry} Courses`} className={element?.attributes?.subIndustry === activefilter || element?.attributes?.subIndustry === filterText ? "filter filter_active" : "filter"} onClick={(e: any) => {
            e.preventDefault();
            handleFilterClick(element?.attributes?.subIndustry, index, element?.id);
          }} key={`filter-${element?.id}`}>
                            <TypoGraphy text={element?.attributes?.subIndustry} variant='Desktop/Body 2/R | 14 |120' />
                        </a>;
        }) : Object.keys(data.filters ?? {})?.map((item: any, index: number) => {
          return <a href={RouteStrings.DYNAMICROUTE(item, 'SUBINDUSTRY', data.filters[item].id)} className={item === filterText ? "filter filter_active" : "filter"} onClick={(e: any) => {
            e.preventDefault();
            handleFilterClick(item, index, data.filters[item].id);
          }} title={`Free ${item} Courses`} key={`filter-${data.filters[item].id}`}>
                                    <TypoGraphy text={item} variant={isMobile ? 'Mobile/Body 2/R | 14 | 120' : 'Desktop/Body 2/R | 14 |120'} />
                                </a>;
        })}
                </div>}
                <div className="cards_wrapper" ref={setElement}>
                    {isIndustry || isSubIndustry ? <IndustryCardRow data={data} pageNumber={1} industryName={industryName ?? ''} subIndustryName={subIndustryName ?? ''} /> : oneRowSection && !isMobile ? <CourseDetailRow data={data} setdisableLeft={setdisableLeft} setdisableRight={setdisableRight} filterText={filterText} /> : <CardRow data={data} disableLeft={disableLeft} disableRight={disableRight} setdisableLeft={setdisableLeft} setdisableRight={setdisableRight} filterText={filterText ?? ''} industryName={industryName} />}
                </div>
                {isMobile && !isIndustry && !isSubIndustry && <a className="see_all_button_wrapper" href={RouteStrings.DYNAMICROUTE(industry?.attributes?.industryName, 'INDUSTRY', industry?.id)} onClick={() => push(RouteStrings.DYNAMICROUTE(industry?.attributes?.industryName, 'INDUSTRY', industry?.id))}>
                    <Button text='See All' textColor='black' textVariant='Mobile/Body 2/M | 14 | 120' borderColor='black' variant='NormalVariant' backgroundColor='white' />
                </a>}
            </div>
        </div>;
};
interface CardRowProps {
  data: any;
  disableRight: boolean;
  setdisableRight: (value: boolean) => void;
  filterText: string;
  disableLeft: boolean;
  setdisableLeft: (value: boolean) => void;
  industryName?: string;
}
interface IndustryCardRowProps {
  data: any;
  pageNumber: number;
  industryName?: string;
  subIndustryName?: string;
}
const IndustryCardRow = ({
  data,
  industryName,
  subIndustryName
}: IndustryCardRowProps) => {
  const {
    isAll,
    isAdvanced,
    isIntermediate,
    isBeginner,
    setshowIndustryContent,
    showIndustryContent
  } = useContext<any>(AppContext);

  // const expertiseFilterFunction = (item: any) => {
  //     if (isAll.state) return true
  //     const { courseDifficulty } = item.attributes
  //     if (isAdvanced && courseDifficulty === 'Advanced') return true;
  //     if (isBeginner && courseDifficulty === 'Beginner') return true;
  //     if (isIntermediate && courseDifficulty === 'Intermediate') return true;
  //     return false
  // }

  let cards = data.cards;
  const [changingCards, setchnagingCards] = useState(cards);
  useEffect(() => {
    setchnagingCards(cards);
  }, [cards]);
  const getAllData = async () => {
    if (!isBeginner && !isIntermediate && !isAdvanced) {
      setchnagingCards(cards);
      return;
    }
    let [beginnerData, intermediateData, advancedData] = await Promise.all([isBeginner ? apiService(API_ENDPOINTS.APP_SERVER_URL + (subIndustryName ? API_ENDPOINTS.subIndustryPageData(subIndustryName ?? '', 1, 'Beginner') : API_ENDPOINTS.industryPageData(industryName ?? '', 1, 'Beginner'))).then((resp: any) => resp.json()).then((data: any) => {
      return data.data;
    }).catch((error: any) => console.log(`error getting data for isBeginner`, error?.response)) : [], isIntermediate ? apiService(API_ENDPOINTS.APP_SERVER_URL + (subIndustryName ? API_ENDPOINTS.subIndustryPageData(subIndustryName ?? '', 1, 'Intermediate') : API_ENDPOINTS.industryPageData(industryName ?? '', 1, 'Intermediate'))).then((resp: any) => resp.json()).then((data: any) => {
      `11`;
      return data.data;
    }).catch((error: any) => console.log(`error getting data for isIntermediate`, error?.response)) : [], isAdvanced ? apiService(API_ENDPOINTS.APP_SERVER_URL + (subIndustryName ? API_ENDPOINTS.subIndustryPageData(subIndustryName ?? '', 1, 'Advanced') : API_ENDPOINTS.industryPageData(industryName ?? '', 1, 'Advanced'))).then((resp: any) => resp.json()).then((data: any) => {
      return data.data;
    }).catch((error: any) => console.log(`error getting data for isAdvanced`, error?.response)) : []]);
    setchnagingCards(beginnerData.concat(intermediateData, advancedData));
  };
  useEffect(() => {
    if (!showIndustryContent && changingCards?.length > 0) {
      setshowIndustryContent(true);
    }
  }, [showIndustryContent, changingCards.length]);
  useEffect(() => {
    if (isAll.state) {
      setchnagingCards(cards);
      return;
    }
    getAllData();
  }, [isAdvanced, isIntermediate, isBeginner, isAll.state]);
  if (!changingCards?.length) {
    setshowIndustryContent(false);
    return <NoCards />;
  }
  if (!changingCards?.length) {
    setshowIndustryContent(false);
    return <NoCards />;
  }
  return <div className="cards_row" data-sentry-component="IndustryCardRow" data-sentry-source-file="index.tsx">
        {changingCards.map((item: any, index: number) => <div className="program_card_wrapper" key={`program_card_${item?.id}`}>
                <ProgramDetailCard courseId={item?.id} desc={item?.attributes?.courseDescription} title={item?.attributes?.courseName} industry={item?.attributes?.industries?.data[0]?.attributes?.industryName} chapters={item?.attributes?.courseCurriculum?.length} difficultyLevel={item?.attributes?.courseDifficulty} mentorDetails={item?.attributes?.mentors?.data[0]?.attributes} rating={item?.attributes?.courseRating} isPremium={item?.attributes?.isPremium} subText={item?.subText} duration={item?.attributes?.premiumCourseDuration} date={item?.date} premiumCardLink={item?.attributes?.premiumCardLink} thumbnailText={item?.attributes?.thumbnailText} />
            </div>)}
    </div>;
};
const CourseDetailRow = ({
  data,
  filterText,
  setdisableRight,
  setdisableLeft
}: any) => {
  const {
    isAll,
    isAdvanced,
    isIntermediate,
    isBeginner
  } = useContext<any>(AppContext);
  const isMobile = useViewType();
  let cards = data?.cards;
  const [changingCards, setchnagingCards] = useState(cards);
  useEffect(() => {
    if (filterText === 'All') {
      setchnagingCards(cards);
    } else {
      apiService(API_ENDPOINTS.APP_SERVER_URL + API_ENDPOINTS.subIndustryPageData(filterText, 1)).then((resp: any) => resp.json()).then((data: any) => {
        setchnagingCards(data.data);
      }).catch((error: any) => error?.response);
    }
  }, [filterText]);
  useEffect(() => {
    if (changingCards.length >= 5) {
      setdisableRight(false);
    } else {
      setdisableRight(true);
      setdisableLeft(true);
    }
  }, [changingCards.length]);
  if (!changingCards?.length) {
    setdisableRight(true);
    setdisableLeft(true);
    return <NoCards />;
  }
  if (changingCards.length === 0) {
    setdisableRight(true);
    setdisableLeft(true);
    return <NoCards />;
  }
  return <div className="cards_row_course_detail" data-sentry-component="CourseDetailRow" data-sentry-source-file="index.tsx">
        {changingCards.map((item: any, index: number) => <div className="program_card_wrapper" key={`program_card_${item?.id}`} style={{
      maxWidth: isMobile ? "100%" : "327px"
    }}>
                <ProgramDetailCard courseId={item?.id} desc={item?.attributes?.courseDescription} title={item?.attributes?.courseName} industry={item?.attributes?.industries?.data[0]?.attributes?.industryName} chapters={item?.attributes?.courseCurriculum?.length} difficultyLevel={item?.attributes?.courseDifficulty} mentorDetails={item?.attributes?.mentors?.data[0]?.attributes} rating={item?.attributes?.courseRating} isPremium={item?.attributes?.isPremium} subText={item?.subText} duration={item?.attributes?.premiumCourseDuration} date={item?.date} premiumCardLink={item?.attributes?.premiumCardLink} thumbnailText={item?.attributes?.thumbnailText} />
            </div>)}
    </div>;
};
const CardRow = ({
  data,
  setdisableRight,
  filterText,
  setdisableLeft,
  industryName
}: CardRowProps) => {
  const {
    isAll,
    isAdvanced,
    isIntermediate,
    isBeginner
  } = useContext<any>(AppContext);
  const isMobile = useViewType();
  const expertiseFilterFunction = (item: any) => {
    if (isAll.state) return true;
    const {
      courseDifficulty
    } = item.attributes;
    if (isAdvanced && courseDifficulty === 'Advanced') return true;
    if (isBeginner && courseDifficulty === 'Beginner') return true;
    if (isIntermediate && courseDifficulty === 'Intermediate') return true;
    return false;
  };
  const cards = data.cards;
  const lastRef = useRef<any>(null);
  const [restCards, setRestCards] = useState([]);
  const [changingCards, setchnagingCards] = useState(cards);
  const getAllData = async () => {
    if (!isBeginner && !isIntermediate && !isAdvanced) {
      setchnagingCards(cards.concat(restCards));
      return;
    }
    let [beginnerData, intermediateData, advancedData] = await Promise.all([isBeginner ? apiService(API_ENDPOINTS.APP_SERVER_URL + API_ENDPOINTS.industryPageData(industryName ?? '', 1, 'Beginner')).then((resp: any) => resp.json()).then((data: any) => {
      return data.data;
    }).catch((error: any) => console.log(`error getting data for isBeginner`, error?.response)) : [], isIntermediate ? apiService(API_ENDPOINTS.APP_SERVER_URL + API_ENDPOINTS.industryPageData(industryName ?? '', 1, 'Intermediate')).then((resp: any) => resp.json()).then((data: any) => {
      return data.data;
    }).catch((error: any) => console.log(`error getting data for isIntermediate`, error?.response)) : [], isAdvanced ? apiService(API_ENDPOINTS.APP_SERVER_URL + API_ENDPOINTS.industryPageData(industryName ?? '', 1, 'Advanced')).then((resp: any) => resp.json()).then((data: any) => {
      return data.data;
    }).catch((error: any) => console.log(`error getting data for isAdvanced`, error?.response)) : []]);
    setchnagingCards(beginnerData.concat(intermediateData, advancedData));
  };
  useEffect(() => {
    if (filterText === 'All') {
      getAllData();
      return;
    }
    apiService(API_ENDPOINTS.APP_SERVER_URL + API_ENDPOINTS.subIndustryPageData(filterText, 1)).then((resp: any) => resp.json()).then((data: any) => {
      setchnagingCards(data.data.filter(expertiseFilterFunction));
    }).catch((error: any) => error?.response);
  }, [filterText, isAdvanced, isIntermediate, isBeginner, isAll.state]);
  useEffect(() => {
    if (changingCards?.length > 0) {
      if (columns <= 1) {
        setdisableRight(true);
      } else {
        setdisableRight(false);
      }
    }
  }, [changingCards.length]);
  useEffect(() => {
    const intersectionObserver = new IntersectionObserver(async (entries: any) => {
      if (entries[0].isIntersecting) {
        let response = await apiService(API_ENDPOINTS.APP_SERVER_URL + API_ENDPOINTS.industryPageData(industryName ?? '', 1, '')).then((resp: any) => resp.json()).catch((error: any) => error?.response);
        setchnagingCards(response.data);
      }
    }, {
      threshold: 0
    });
    if (lastRef.current) intersectionObserver.observe(lastRef.current);
    () => {
      intersectionObserver.disconnect();
    };
  }, []);
  if (!data?.cards) {
    setdisableRight(true);
    setdisableLeft(true);
    return <NoCards />;
  }
  if (changingCards.length === 0) {
    setdisableRight(true);
    setdisableLeft(true);
    return <NoCards />;
  }
  let columns = changingCards.length < 6 ? 1 : Math.round(changingCards.length / 6);
  let arr = new Array(isMobile ? 1 : columns);
  arr.fill(6);
  return arr.map((row: number, index: number) => {
    let start = index * row,
      end = isMobile ? 3 : (index + 1) * row;
    return <div className="cards_row" key={`card_row_${index}`} ref={index === 1 ? lastRef : null}>
            {changingCards.slice(start, end).map((item: any, index: number) => <div className="program_card_wrapper" key={`program_card_${item?.id}`}>
                    <ProgramDetailCard courseId={item?.id} desc={item?.attributes?.courseDescription} title={item?.attributes?.courseName} industry={item?.attributes?.industries?.data[0]?.attributes?.industryName} chapters={item?.attributes?.courseCurriculum?.length} difficultyLevel={item?.attributes?.courseDifficulty} mentorDetails={item?.attributes?.mentors?.data[0]?.attributes} rating={item?.attributes?.courseRating} isPremium={item?.attributes?.isPremium} subText={item?.subText} duration={item?.attributes?.premiumCourseDuration} date={item?.date} premiumCardLink={item?.attributes?.premiumCardLink} thumbnailText={item?.attributes?.thumbnailText} />
                </div>)}
        </div>;
  });
};
export default CardSection;